import { useState, useEffect, useCallback } from 'react';
import { AuthClient } from '../auth/AuthClient';
export function useAuth() {
    const [authState, setAuthState] = useState(AuthClient.getState());
    useEffect(() => {
        const unsubscribe = AuthClient.subscribe(setAuthState);
        return () => {
            unsubscribe();
        };
    }, []);
    return {
        state: authState,
        isAuthenticated: authState.status === 'authenticated',
        isLoading: authState.status === 'loading',
        user: authState.status === 'authenticated' ? authState.user : null,
        error: authState.status === 'error' ? authState.error : null,
        login: useCallback(() => AuthClient.login(), []),
        logout: useCallback(() => AuthClient.logout(), []),
        getAccessToken: () => AuthClient.getAccessToken(),
        viewerMode: authState.status === 'authenticated' ? authState.viewerMode : false,
        setViewerMode: useCallback((enabled) => AuthClient.setViewerMode(enabled), []),
    };
}
export function usePermission(action) {
    const { user } = useAuth();
    if (!user) {
        return false;
    }
    return user.actions.includes(action);
}
export function useHasAnyPermission(actions) {
    const { user } = useAuth();
    if (!user) {
        return false;
    }
    return actions.some((action) => user.actions.includes(action));
}
export function useHasAllPermissions(actions) {
    const { user } = useAuth();
    if (!user) {
        return false;
    }
    return actions.every((action) => user.actions.includes(action));
}
export function useUserRole() {
    const { user } = useAuth();
    return user?.role || null;
}
